import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IInventoryTemplatePresetRepository } from '@/coreInfrastructureModule/interfaces/IInventoryTemplatePresetRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryTemplatePreset, IInventoryTemplatePresetUpsertRequest } from '../domains/entities/InventoryTemplate';
import { InventoryTemplatePresetAdapter } from '../adapters/InventoryTemplatePresetAdapter';

/**
 * 出力条件プリセットを新規登録するユースケース
 */
export class CreateInventoryTemplatePresetUseCase {
  /**
   * コンストラクタ
   * @param repository - 出力条件プリセットを登録するリポジトリ
   */
  constructor(private readonly repository: IInventoryTemplatePresetRepository) {}

  /**
   * プリセットを新規登録する
   * @param request - 登録内容
   */
  public Execute = async (request: IInventoryTemplatePresetUpsertRequest): Promise<INetworkResult<IInventoryTemplatePreset, IError>> => {
    const result = await this.repository.create(InventoryTemplatePresetAdapter.toApiUpsertRequest(request));
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: InventoryTemplatePresetAdapter.toEntity(result.status.data.preset),
        },
      };
    }

    return { status: result.status };
  };
}
